import React from 'react'
import { TrialPreEndModalCard } from 'Features/accountSettings/components/Billing/TrialPreEndModal/TrialPreEndModal.styled'
import {
  TrialPreEndModalCardNumber,
  TrialPreEndModalCardText,
  TrialPreEndModalCardTextWrapper,
} from 'Features/accountSettings/components/Billing/TrialPreEndModal/PaidMarketingData/PaidMarketingData.styled'
import { Tooltip } from '@clickcease/cc-client-components-lib'
import { useTranslation } from 'react-i18next'
import { InvalidRequestsStyled } from './InvalidRequests.styled'

export const InvalidRequests = ({
  invalidRequests,
  bundle,
  text,
}: {
  invalidRequests: string
  bundle?: boolean
  text?: string
}) => {
  const { t } = useTranslation('accountSettings')
  return (
    <TrialPreEndModalCard bundle={bundle}>
      <InvalidRequestsStyled>
        <TrialPreEndModalCardTextWrapper>
          <TrialPreEndModalCardText bundle={bundle}>
            {t(text ? text : 'trial_pre_end_modal.invalid_requests')}
          </TrialPreEndModalCardText>
          <Tooltip
            trigerStyle={{
              style: {
                color: 'var(--colors-neutral)',
                position: bundle ? 'absolute' : 'relative',
                top: '25px',
                left: bundle ? '93px' : 'auto',
              },
            }}
            tooltiptContent={t('trial_pre_end_modal.invalid_requests_tooltip')}
          />
        </TrialPreEndModalCardTextWrapper>
        <TrialPreEndModalCardNumber>{invalidRequests}</TrialPreEndModalCardNumber>
      </InvalidRequestsStyled>
    </TrialPreEndModalCard>
  )
}
